import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { protoColors } from '../../../theme/tokens';

export const MapFrame = styled(Box)(() => ({
  height: '420px',
  borderRadius: '16px',
  overflow: 'hidden',
  border: `1px solid ${protoColors.border}`,
  '& .rede-proto-capacity-map': {
    width: '100%',
    height: '100%',
  },
}));

export const Placeholder = styled(Box)(() => ({
  height: '420px',
  borderRadius: '16px',
  border: `1px dashed ${protoColors.border}`,
  backgroundColor: protoColors.surfaceSubtle,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  textAlign: 'center',
  padding: '24px',
  color: protoColors.textMuted,
}));

export const Bubble = styled('span', {
  shouldForwardProp: (prop) => prop !== 'size' && prop !== 'color',
})<{ size: number; color: string }>(({ size, color }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: `${size}px`,
  height: `${size}px`,
  borderRadius: '50%',
  backgroundColor: `${color}D9`,
  border: '2px solid #FFFFFF',
  boxShadow: '0 1px 4px rgba(0,0,0,0.35)',
  color: '#FFFFFF',
  fontSize: size >= 30 ? '12px' : '10px',
  fontWeight: 700,
  cursor: 'default',
}));

export const FilterBar = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '12px',
  marginBottom: '16px',
}));

export const CapacityLayout = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '16px',
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: '1fr',
  },
}));

export const TableScroll = styled(Box)(() => ({
  maxHeight: '420px',
  overflowY: 'auto',
}));
